import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation, Redirect, Link } from "react-router-dom";
import {
  signIn,
  resetSignIn,
  signInGoogle,
  signInFacebook,
  signInApple,
  getRegisterOtp,
} from "../../actions/auth-action";
import { changeTimezone } from "../../actions/setting-action";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import { GoogleLogin } from "react-google-login";
import { gapi } from 'gapi-script';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import AppleLogin from "react-apple-login";
import "./Login.scss";
import { getCurrentTimeZone } from "../../utils/Utils";
import Header from "../common/Header";
import Footer from "../common/Footer";
import queryString from "query-string";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import GoogleLoginComponent from "./GoogleLoginComponent";

const Login = (props) => {
  const {
    resetSignIn,
    signIn,
    signInGoogle,
    signInFacebook,
    signInApple,
    getData,
  } = props;
  const location = useLocation();
  const host = window.location.origin;
  const hash = window.location.hash;
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const signInStart = useSelector((state) => state.auth.signInStart);
  const { search } = useLocation();
  const { t } = useTranslation();
  const query = queryString.parse(search);
  const pathname = (location.state && location.state.from) || "/dashboard";
  const gaConfirmed = useSelector((state) => state.auth.gaConfirmed);
  const gaEnabled = useSelector((state) => state.settings.gaEnabled);

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  
  
  
  //const clientId = '99775611904-49dav5kpn80bsiqo69rve37pa3qi8r0s.apps.googleusercontent.com';
  const clientId = '773198411579-pi9k49bta0ofb81dbesp6b3dshsvs0lk.apps.googleusercontent.com';
  

  useEffect(() => {
    resetSignIn();
    return () => resetSignIn();
  }, []);

  
 

  useEffect(() => {
    const currentTimezone = getCurrentTimeZone();
    window.timezone = currentTimezone;
  }, []);

  const login = (e) => {
    e.preventDefault();
    signIn(email, pass);
  };

  const loginGoogle = (res) => {
    const { credential } = res;
    signInGoogle(credential);
  };


  const loginFacebook = (res) => {
    const { accessToken, userID } = res;
    signInFacebook(accessToken, userID);
  };

  const loginApple = (res) => {
    console.log("Apple", res);
  };

  const failedLoginGoogle = (res) => {
    console.log("Failed login Google", res);
  };

  useEffect(() => {
    if (hash) {
      const idTokenIndex = hash.indexOf("id_token");
      const idToken = hash.slice(idTokenIndex + 9);
      signInApple(idToken);
    }
  }, [hash]);

  if (token) {
    if (user && user.email_verified_at) {
      if (gaEnabled && !gaConfirmed) return <Redirect to="/ga/confirm" />;
      return <Redirect to={pathname} />;
    }
    return <Redirect to="/verify-otp" />;
  }

  return (
    <>
      {/* <Header /> */}
      <div fluid="true">
        <Row className="justify-content-center login-panel">
          {/* <Col className="left-panel">
            <div>
              <img src="/images/login.png" className="feature-image" alt="banner" width={500} height={350} />
            </div>
          </Col> */}
          <Col className="right-panel">
            <div className="signup-panel">
              
             
              <Form>
                <div className="text-center">
                <img
                alt=""
                src="/images/ch2.png"
                height="100"
                width={200}
                className="d-inline-block align-top"
              />
              <h6 className="mt-3 header-text text-center">{t("log-in-header")}</h6>
                </div>
                <Form.Group controlId="formBasicEmail" className="ch-form">
                  <Form.Control
                    type="email"
                    placeholder={t("email")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicPassword" className="ch-form">
                  <Form.Control
                    type="password"
                    placeholder={t("Password")}
                    value={pass}
                    onChange={(e) => setPass(e.target.value)}
                  />
                </Form.Group>

                <div className="forgot-pass">
                  <Link to="/forget-pass">{t("f-pass")}</Link>
                </div>
                <div className="my-3">
                  <Button type="submit" onClick={login} className={"ch-button"}>
                    {signInStart ? "PROCESSING..." : t("login-now")}
                  </Button>
                </div>
                <Alert
                  show={errorMessage != null}
                  variant="danger"
                  className="mt-2"
                >
                  {errorMessage && errorMessage}
                </Alert>
              </Form>
              <div className="text-center mt-5">{t("or-login-with")}</div>
              <div className="social-login-div">
              <div className="d-flex justify-content-center mt-3">
                {/* <div><FacebookLogin
                  appId="649699255566506"
                  fields="name,email,picture"
                  callback={loginFacebook}
                  render={(renderProp) => {
                    return (
                      <div className="circle text-center">
                        <a onClick={renderProp.onClick}>
                          <i className="fab fa-facebook-f facebook"></i>
                        </a>
                      </div>
                    );
                  }}
                /></div> */}
                <div>
                  <GoogleLoginComponent clientId={clientId}></GoogleLoginComponent>
                </div>
                {/* <div>
                  <AppleLogin
                        clientId="ventures.novum.stockhero"
                        redirectURI={`${host}/login`}
                        callback={loginApple}
                        responseType="code id_token"
                        responseMode="fragment"
                        render={(renderProp) => {
                          return (
                            <div className="circle text-center">
                              <a onClick={renderProp.onClick}>
                                <i className="fab fa-apple apple"></i>
                              </a>
                            </div>
                          );
                        }}
                      />
                  </div> */}
              </div>
              </div>
              {/* <div className="mt-4 text-center">
                <FacebookLogin
                  appId="766840544447685"
                  fields="name,email,picture"
                  callback={loginFacebook}
                  render={(renderProp) => {
                    return (
                      <div className="circle text-center">
                        <a onClick={renderProp.onClick}>
                          <i className="fab fa-facebook-f facebook"></i>
                        </a>
                      </div>
                    );
                  }}
                />
                
                
              </div> */}

              <div className="text-center mt-4">
                <hr />
                <span className="mr-2">{t("no-acc")}</span>
                <Link to="/signup">{t("create-acc")}</Link>
              </div>
            </div>
          </Col>
        </Row>
        <Footer />
      </div>
    </>
  );
};
export default connect(null, {
  signIn,
  resetSignIn,
  signInGoogle,
  signInFacebook,
  signInApple,
  changeTimezone,
  getRegisterOtp,
})(Login);
